import React, { useEffect, useState } from 'react';
import { Metrics } from './Metrics';
import { GoogleTagManager } from './GoogleTagManager';
import { LinkedinInsight } from './LinkedinInsight';
import { getConsentDecision } from './util';

/**
 * AnalyticsScriptLoader is used to load any scripts containing cookies which require user consent before they can be set
 * This way we block the use of the cookies until the user has given consent
 */
export const AnalyticsScriptLoader = () => {
  const [consentLevel, setConsentLevel] = useState(0);

  useEffect(() => {
    const consentDecision = getConsentDecision();
    
    // if 'notice_preference' cookie is already set the consent level is updated
    if(consentDecision && consentDecision !== 'awaiting-user-response') {
      setConsentLevel(consentDecision);
      return;
    }
    
    const handleMessage = e => {
      if (!e.data) return;

      const response = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;

      if (response && response.message === 'submit_preferences') {
        const value = response.data.value ? response.data.value : response.data;
        const level = +value.charAt(value.length - 1);
        setConsentLevel(level);
      }
    };

    const onLoad = () => {
      // after script is loaded 'notice_behavior' cookie should already be set
      const consentDecision = getConsentDecision();

      if(!consentDecision) {
        // if no cookie is available at this point sth went wrong
        console.warn(`Cookies consent defaulted to 'Required Only'`);
      } else if(consentDecision === 'awaiting-user-response') {
        // listener to receive the decision from the user
        window.addEventListener('message', handleMessage, false);
      } else {
        setConsentLevel(consentDecision);
      }
    }

    const cookieConsentScript = document.getElementById('cookie-consent-script');

    /**
     * If cooike consent script is not present will throw null pointer exception
     * https://auth0team.atlassian.net/browse/DXDOCS-53
     */
    if(cookieConsentScript) {
      cookieConsentScript.addEventListener('load', onLoad);
    }
    
    return () => {
      cookieConsentScript && cookieConsentScript.removeEventListener('load', onLoad);
      window.removeEventListener('message', handleMessage, false);
    }
  }, []);

  return (
    <>
      <Metrics consentLevel={consentLevel} />
      <GoogleTagManager consentLevel={consentLevel} />
      <LinkedinInsight consentLevel={consentLevel} />
    </>
  );
};
